import React, { useEffect, useState } from "react";
import { PrescriptionIcon } from "../../../landingscreen/modals/svgs";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import api from "../../../api/api";
import ToastMessage from "../../../utils/mui/righttoptoast";
import { useDispatch } from "react-redux";
import { setFormData } from "../../../reduxtoolkit/orders/prescription";
import { useParams } from "react-router-dom";
import { getPracticeId } from "../../../config/practice";

// The fields v1 POST /rx/patient/{pid}/create refuses without (post_rx.py create_prescription), as
// the person sees them. TSK-8926 (1): checked here before submit, so the server's refusal is rare.
export const missingPrescriptionFields = ({ medication, medicationid, ordertypeid, diagnosiscode, pharmacy, form }) => {
  const blank = (v) => v === undefined || v === null || String(v).trim() === "";
  const missing = [];
  if (blank(medication) || blank(medicationid) || blank(ordertypeid)) missing.push("Medication (pick it from the list)");
  if (blank(diagnosiscode)) missing.push("Diagnosis (pick it from the list)");
  if (blank(form?.dosagequantity)) missing.push("Dosage Quantity");
  if (blank(form?.dqunit)) missing.push("Unit");
  if (blank(form?.frequency)) missing.push("Frequency");
  if (blank(form?.duration)) missing.push("Duration (days)");
  if (blank(form?.quantity)) missing.push("Total Quantity");
  if (blank(pharmacy)) missing.push("Pharmacy");
  return missing;
};

// The server's own words for a refused prescription: v1's 400 "message", FastAPI's 422 field list,
// or a 500's message. TSK-8926 (1): the modal said only "Error submitting prescription".
const FIELD_LABELS = {
  medicationid: "Medication (pick it from the list)", ordertypeid: "Medication (pick it from the list)",
  medication: "Medication", diagnosissnomedcode: "Diagnosis", diagnosis: "Diagnosis", duration: "Duration",
  frequency: "Frequency", dosagequantity: "Dosage Quantity", dosagequantityunit: "Unit",
  totalquantity: "Total Quantity", pharmacyname: "Pharmacy", numrefillsallowed: "Refills Allowed",
  provider_name: "Provider", lov: "Level of visit",
};
export const prescriptionErrorMessage = (err) => {
  const body = err?.response?.data;
  if (Array.isArray(body?.detail)) {
    const names = [...new Set(body.detail.map((d) => {
      const key = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : "";
      return FIELD_LABELS[key] || key || d?.msg;
    }).filter(Boolean))];
    if (names.length) return `Please check: ${names.join(", ")}`;
  }
  const text = (typeof body === "string" ? body : body?.message || body?.detail) || "";
  if (text && typeof text === "string") return text;
  return "Error submitting prescription";
};

export const PrescriptionModal = ({ onClose, selectedpharma,isOpen, userdata }) => {
  const dispatch = useDispatch();
  const { dt } = useParams();
  const practiseid = getPracticeId();

  // Form state
  const [formdata, setFormdata] = useState({
    dosagequantity: "",
    dqunit: "",
    frequency: "",
    duration: "",
    note: "",
    quantity: ""
  });

  // Medication states
  const [MedicationText, setMedicationText] = useState("");
  const [MedicationSuggestions, setMedicationSuggestions] = useState([]);
  const [topmedication, setTopMedication] = useState([]);
  const [isMedicationSelected, setIsMedicationSelected] = useState(false);
  const [medicationid, setMedicationId] = useState("");
  const [ordertypeid, setOrderTypeId] = useState("");

  // Diagnosis states
  const [diagnosisText, setDiagnosisText] = useState("");
  const [diagnosisSuggestions, setDiagnosisSuggestions] = useState([]);
  const [isDiagnosisSelected, setIsDiagnosisSelected] = useState(false);
  const [diagnosiscode, setDiagnosisCode] = useState("");
  const [icd, setIcd] = useState("");

  // Pharmacy states
  const [pharmacyText, setPharmacyText] = useState("");
  const [pharmacySuggestions, setPharmacySuggestions] = useState([]);
  const [isPharmacySelected, setIsPharmacySelected] = useState(false);
const [isEditingPharma, setIsEditingPharma] = useState(false);
  // TSK-8926 (3): once the person edits or picks a pharmacy, a later default-pharmacy answer does not
  // overwrite it. (The create API takes the pharmacy NAME only; it has no pharmacy id field.)
  const [pharmacyTouched, setPharmacyTouched] = useState(false);
  const [showMissing, setShowMissing] = useState(false);
  // Refills
  const [activeButton, setActiveButton] = useState(3);

  // Toast + loading
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [loading, setLoading] = useState(false);

  const handleButtonClick = (index) => setActiveButton(index);
  const handleToastClose = () => setOpenToast(false);

  const handleClear = () => {
    setFormdata({ dosagequantity: "", dqunit: "", frequency: "", duration: "", note: "", quantity: "" });
    setMedicationText("");
    setMedicationId("");
    setOrderTypeId("");
    setMedicationSuggestions([]);
    setIsMedicationSelected(false);
    setDiagnosisText("");
    setDiagnosisSuggestions([]);
    setDiagnosisCode("");
    setIcd("");
    setIsDiagnosisSelected(false);
    setPharmacyText("");
    setPharmacySuggestions([]);
    setIsPharmacySelected(false);
    setPharmacyTouched(false);
    setShowMissing(false);
  };

  // Fetch suggestions
  const fetchDiagnosisSuggestions = async () => {
    if (diagnosisText.trim().length > 1) {
      try {
        const res = await api.post(`/v1/${practiseid}/orders/patient/${userdata.patientid}/get-search-diagnosis`, { searchVal: diagnosisText });
        if (res.status === 200) setDiagnosisSuggestions(res.data.slice(0, 5) || []);
      } catch (err) {
        console.error(err);
      }
    }
  };
useEffect(() => {
  if (selectedpharma && !pharmacyTouched) {
    setPharmacyText(selectedpharma.clinicalprovidername || "");
    setIsPharmacySelected(true);
    setIsEditingPharma(false); // not editable initially
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedpharma]);
  const fetchMedicationSuggestions = async () => {
    if (MedicationText.trim().length > 1) {
      try {
        const res = await api.post(`/v1/${practiseid}/rx/medicationlookup/5`, { lookup: MedicationText });
        if (res.status === 200) setMedicationSuggestions(res.data || []);
      } catch (err) {
        console.error(err);
      }
    }
  };

  const fetchPharmacySuggestions = async () => {
    if (pharmacyText.trim().length > 1) {
      try {
        const res = await api.post(
          `/v1/${practiseid}/rx/patient/${userdata.patientid}/department/${userdata.departmentid}/pharmalook`,
          { facility_name: pharmacyText }
        );
        if (res.status === 200) setPharmacySuggestions(res.data.slice(0, 5) || []);
      } catch (err) {
        console.error(err);
      }
    }
  };

  const fetchTopMedication = async () => {
    try {
      const res = await api.get(`/v1/${practiseid}/rx/${userdata.patientid}/topmedication/4/0`);
      if (res.status === 200) setTopMedication(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isOpen) fetchTopMedication();
  }, [isOpen]);

  useEffect(() => {
    if (diagnosisText && !isDiagnosisSelected) {
      const t = setTimeout(fetchDiagnosisSuggestions, 800);
      return () => clearTimeout(t);
    }
  }, [diagnosisText]);

  useEffect(() => {
    if (MedicationText && !isMedicationSelected) {
      const t = setTimeout(fetchMedicationSuggestions, 800);
      return () => clearTimeout(t);
    }
  }, [MedicationText]);

  useEffect(() => {
    if (pharmacyText && !isPharmacySelected) {
      const t = setTimeout(fetchPharmacySuggestions, 800);
      return () => clearTimeout(t);
    }
  }, [pharmacyText]);

  const missing = missingPrescriptionFields({
    medication: MedicationText, medicationid, ordertypeid, diagnosiscode, pharmacy: pharmacyText, form: formdata,
  });
  const isMissing = (label) => showMissing && missing.some((m) => m.startsWith(label));
  const fieldClass = (label, base) => `${base}${isMissing(label) ? " border-red-500" : ""}`;

  const submitMedication = async () => {
    if (missing.length) {
      setShowMissing(true);
      setToastMessage(`Please fill: ${missing.join(", ")}`);
      setToastSeverity("error");
      setOpenToast(true);
      return;
    }
    try {
      setLoading(true);
      dispatch(setFormData(formdata));
      const check = await api.post(`/v1/${practiseid}/orders/patient/${userdata.patientid}/prescription/check`, {
        medicationname: MedicationText
      });

      if (check.status === 200) {
        setToastMessage("Medication already exists");
        setToastSeverity("warning");
        setOpenToast(true);
        return;
      }

      let payload = {
        pat_name: `${userdata.firstname || ""} ${userdata.lastname || ""}`.trim(),
        encounterid: typeof userdata.encounterid === "number" ? userdata.encounterid : undefined,
        ordertypeid,
        medication: MedicationText,
        provider_name: userdata.providername,
        medicationid,
        pharmacyname: pharmacyText,
        diagnosissnomedcode: diagnosiscode,
        duration: formdata.duration,
        frequency: formdata.frequency,
        dosagequantityunit: formdata.dqunit,
        dosagequantity: formdata.dosagequantity,
        numrefillsallowed: activeButton,
        totalquantity: formdata.quantity,
        confirm_status: "C",
        orderdate:
          dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
            ? dt.split(" ")[0]
            : new Date().toISOString().split("T")[0],
        providernote: formdata.note,
        lov: 3,
        tov: "FOLLOW UP",
        diagnosis: icd
      };
      if (payload.encounterid === undefined) delete payload.encounterid;

      const res = await api.post(`/v1/${practiseid}/rx/patient/${userdata.patientid}/create`, payload);

      if (res.status === 200) {
      
        setToastMessage("Medication added successfully!");
        setToastSeverity("success");
        setOpenToast(true);
        setTimeout(() => {
          handleClear();
          onClose();
        }, 1500);
      } else {
        setToastMessage(res?.message || "Error submitting prescription");
        setToastSeverity("error");
        setOpenToast(true);
      }
    } catch (err) {
      console.error(err);
      setToastMessage(prescriptionErrorMessage(err));
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
     <div className="fixed inset-0 z-50 bg-black/50 overflow-y-auto">
     <div className="flex justify-center min-h-screen">
          <div className="relative w-[900px] max-w-full rounded-2xl bg-white shadow-2xl my-8">
          {/* Header */}
          <div className="flex items-center justify-between rounded-t-2xl bg-gradient-to-r from-[#155DFC] to-[#155DFC] px-6 py-4 text-white">
            <div className="flex items-center gap-4">
              <div>{PrescriptionIcon}</div>
              <div className="flex flex-col items-start">
                <span className="text-lg font-medium">New Prescription</span>
                <span className="text-[12px] font-light text-[#DCFCE7]">Search and select medication to prescribe</span>
              </div>
            </div>
            <button onClick={() => { handleClear(); onClose(); }} className="text-white hover:text-gray-200">
              <CloseIcon />
            </button>
          </div>

          {/* Body */}
          <div className="p-6 text-start space-y-6">
            {/* Medication search */}
            <div>
              <label className="block text-sm font-medium mb-2 text-[#364153]">Medication *</label>
              <div className="relative">
                <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9AA4B2]" />
                <input
                  value={MedicationText}
                  onChange={(e) => {
                    // typing again un-picks the medication: the server needs the picked id
                    setMedicationText(e.target.value);
                    setIsMedicationSelected(false);
                    setMedicationId("");
                    setOrderTypeId("");
                  }}
                  className={fieldClass("Medication", "w-full rounded-xl border border-[#E5E7EB] pl-11 pr-4 py-3 text-base font-light")}
                  placeholder="Type medication name…"
                />
              </div>
              {MedicationText && !isMedicationSelected && MedicationSuggestions.length > 0 && (
                <ul className="mt-2 border rounded-xl bg-white">
                  {MedicationSuggestions.map((s, i) => (
                    <li
                      key={i}
                      onClick={() => {
                        setMedicationText(s.medication);
                        setMedicationId(s.medicationid);
                        setOrderTypeId(s.clinicalordertypeid);
                        setIsMedicationSelected(true);
                        setMedicationSuggestions([]);
                      }}
                      className="p-2 hover:bg-gray-100 cursor-pointer text-sm"
                    >
                      {s.medication}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Top Meds */}
            {topmedication.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {topmedication.map((item, i) => (
                  <span
                    key={i}
                    onClick={() => {
                      setMedicationText(item.medication);
                      setMedicationId(item.medicationid);
                      setOrderTypeId(item.clinicalordertypeid);
                      setIsMedicationSelected(true);
                    }}
                    className={`cursor-pointer px-3 py-1 rounded-full text-xs border shadow-sm ${
                      MedicationText === item.medication ? "bg-[#155DFC] text-white" : "bg-white text-[#1D2951]"
                    }`}
                  >
                    {item.medication}
                  </span>
                ))}
              </div>
            )}

            {/* Diagnosis */}
            <div>
              <label className="block text-sm font-medium mb-2 text-[#364153]">Diagnosis *</label>
              <input
                value={diagnosisText}
                onChange={(e) => {
                  setDiagnosisText(e.target.value);
                  setIsDiagnosisSelected(false);
                  setDiagnosisCode("");
                  setIcd("");
                }}
                className={fieldClass("Diagnosis", "w-full rounded-xl border border-[#E5E7EB] p-3")}
                placeholder="Search diagnosis…"
              />
              {diagnosisText && !isDiagnosisSelected && diagnosisSuggestions.length > 0 && (
                <ul className="mt-2 border rounded-xl bg-white">
                  {diagnosisSuggestions.map((s, i) => (
                    <li
                      key={i}
                      onClick={() => {
                        setDiagnosisText(s.condition_name);
                        setDiagnosisCode(s.snomed_code);
                        setIcd(s.icd10);
                        setDiagnosisSuggestions([]);
                        setIsDiagnosisSelected(true);
                      }}
                      className="p-2 hover:bg-gray-100 cursor-pointer text-sm"
                    >
                      {s.condition_name}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Dosage / Unit */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm mb-2">Dosage Quantity *</label>
                <input
                  value={formdata.dosagequantity}
                  onChange={(e) => setFormdata({ ...formdata, dosagequantity: e.target.value })}
                  aria-label="Dosage Quantity"
                  className={fieldClass("Dosage Quantity", "w-full rounded-xl border p-3")}
                />
              </div>
              <div>
                <label className="block text-sm mb-2">Unit *</label>
                <input
                  value={formdata.dqunit}
                  onChange={(e) => setFormdata({ ...formdata, dqunit: e.target.value })}
                  aria-label="Unit"
                  className={fieldClass("Unit", "w-full rounded-xl border p-3")}
                />
              </div>
            </div>

            {/* Frequency / Duration */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm mb-2">Frequency *</label>
                <input
                  value={formdata.frequency}
                  onChange={(e) => setFormdata({ ...formdata, frequency: e.target.value })}
                  aria-label="Frequency"
                  className={fieldClass("Frequency", "w-full rounded-xl border p-3")}
                />
              </div>
              <div>
                <label className="block text-sm mb-2">Duration (days) *</label>
                <input
                  value={formdata.duration}
                  onChange={(e) => setFormdata({ ...formdata, duration: e.target.value })}
                  aria-label="Duration (days)"
                  className={fieldClass("Duration (days)", "w-full rounded-xl border p-3")}
                />
              </div>
            </div>

            {/* Pharmacy */}
            {/* <div>
              <label className="block text-sm mb-2">Pharmacy</label>
              <div className="flex items-center gap-2">
                <input
                  value={pharmacyText}
                  onChange={(e) => setPharmacyText(e.target.value)}
                  className="w-full rounded-xl border p-3"
                  placeholder="Enter Pharmacy…"
                />
                <FontAwesomeIcon icon={faPenToSquare} className="text-[#155DFC]" />
              </div>
              {pharmacyText && !isPharmacySelected && pharmacySuggestions.length > 0 && (
                <ul className="mt-2 border rounded-xl bg-white">
                  {pharmacySuggestions.map((s, i) => (
                    <li
                      key={i}
                      onClick={() => {
                        setPharmacyText(s.name);
                        setIsPharmacySelected(true);
                        setPharmacySuggestions([]);
                      }}
                      className="p-2 hover:bg-gray-100 cursor-pointer text-sm"
                    >
                      {s.name}
                    </li>
                  ))}
                </ul>
              )}
            </div> */}
<div>
  <label className="block text-sm mb-2 text-[#364153]">Pharmacy *</label>
  <div className="flex items-center gap-2">
    <input
      value={pharmacyText}
      onChange={(e) => { setPharmacyTouched(true); setPharmacyText(e.target.value); }}
      aria-label="Pharmacy"
      className={fieldClass("Pharmacy", `w-full rounded-xl border p-3 ${isEditingPharma ? "" : "bg-gray-100 cursor-not-allowed"}`)}
      placeholder="Enter Pharmacy…"
     disabled={!isEditingPharma && selectedpharma ? true : false}

    />
    <FontAwesomeIcon
      icon={faPenToSquare}
      className="text-[#155DFC] cursor-pointer"
      onClick={() => {
        
        setIsEditingPharma(true)
        setPharmacyTouched(true)
        setIsPharmacySelected(false); 
      }
      }
    />
  </div>
  {isEditingPharma && pharmacyText && !isPharmacySelected && pharmacySuggestions.length > 0 && (
    <ul className="mt-2 border rounded-xl bg-white">
      {pharmacySuggestions.map((s, i) => (
        <li
          key={i}
          onClick={() => {
            setPharmacyText(s.name);
            setPharmacyTouched(true);
            setIsPharmacySelected(true);
            setPharmacySuggestions([]);
            setIsEditingPharma(false); // stop editing after selecting
          }}
          className="p-2 hover:bg-gray-100 cursor-pointer text-sm"
        >
          {s.name}
        </li>
      ))}
    </ul>
  )}
</div>
            {/* Notes */}
            <div>
              <label className="block text-sm mb-2">Patient Note</label>
              <textarea
                value={formdata.note}
                onChange={(e) => setFormdata({ ...formdata, note: e.target.value })}
                className="w-full rounded-xl border p-3"
                rows={3}
                placeholder="Type note here…"
              />
            </div>

            {/* Refills / Total Quantity */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm mb-2">Refills Allowed</label>
                <div className="flex gap-2">
                  {[0, 1, 2, 3].map((n) => (
                    <button
                      key={n}
                      onClick={() => handleButtonClick(n)}
                      className={`px-3 py-1 rounded-lg border ${
                        activeButton === n ? "bg-[#155DFC] text-white" : "bg-white text-[#1D2951]"
                      }`}
                    >
                      {n}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="block text-sm mb-2">Total Quantity *</label>
                <input
                  value={formdata.quantity}
                  onChange={(e) => setFormdata({ ...formdata, quantity: e.target.value })}
                  aria-label="Total Quantity"
                  className={fieldClass("Total Quantity", "w-full rounded-xl border p-3")}
                />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between border-t px-6 py-4">
            <span className="text-xs text-[#4A5565]">Fill the form and add medication</span>
            <div className="flex gap-3">
              <button onClick={() => { handleClear(); onClose(); }} className="px-4 py-2 rounded-lg border text-xs">
                Cancel
              </button>
              <button
                onClick={submitMedication}
                disabled={loading}
                className={`px-4 py-2 rounded-lg text-xs text-white ${loading ? "bg-gray-400" : "bg-[#155DFC]"}`}
              >
                {loading ? "Submitting..." : "Add Medication"}
              </button>
            </div>
          </div></div>
        </div>
      </div>

      <ToastMessage message={toastMessage} severity={toastSeverity} open={openToast} handleClose={handleToastClose} />
    </>
  );
};
